import { Expose, Type } from 'class-transformer';
import { SopWithRelationshipResponseDto } from '../complaints-process-config/sop-relationship.dto';

export class RecallProcessConfigResponseDto {
    /**
     * Unique identifier
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Client Information Record ID reference
     * @example '123e4567-e89b-12d3-a456-426614174001'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * Emergency Contact 1 ID
     * @example '123e4567-e89b-12d3-a456-426614174002'
     */
    @Expose()
    emergencyContact1Id?: string;

    /**
     * Emergency Contact 2 ID
     * @example '123e4567-e89b-12d3-a456-426614174003'
     */
    @Expose()
    emergencyContact2Id?: string;

    /**
     * Reporting to HC Contact ID
     * @example '123e4567-e89b-12d3-a456-426614174004'
     */
    @Expose()
    reportingToHcContactId?: string;

    /**
     * Follow-up to HC Contact ID
     * @example '123e4567-e89b-12d3-a456-426614174005'
     */
    @Expose()
    followUpToHcContactId?: string;

    /**
     * Notes
     * @example 'Emergency recall procedures'
     */
    @Expose()
    notes?: string;

    /**
     * Creation date
     * @example '2024-01-01T00:00:00.000Z'
     */
    @Expose()
    createdAt: Date;

    /**
     * Last update date
     * @example '2024-01-01T00:00:00.000Z'
     */
    @Expose()
    updatedAt: Date;

    @Expose()
    @Type(() => SopWithRelationshipResponseDto)
    sops?: SopWithRelationshipResponseDto[];
}
